<template>
	<div class="avatar-chat-container">
		<div class="chat-header sticky">
			<div class="chat-header-content">
				<div class="chat-title">
					<div class="header-avatar" :style="avatarImageStyle"></div>
					<h1>{{ username }}'s AI Twin</h1>
				</div>
			</div>
		</div>

		<div class="welcome-message-container">
			<h2 class="welcome-text">Hi <span class="emoji">👋</span> How can I help?</h2>
		</div>

		<div class="chat-input-container">
			<div class="chat-input-wrapper">
				<textarea placeholder="Ask me anything..." class="message-input" rows="4" spellcheck="false" disabled></textarea>
				<button class="send-button disabled">
					<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
						<path d="M12 19V5m0 0l-7 7m7-7l7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AvatarChatInterface',
		props: {
			avatarImage: {
				type: String,
				default: '',
			},
			username: {
				type: String,
				default: 'Creator',
			},
			userProfileImage: {
				type: String,
				default: '',
			},
		},
		computed: {
			avatarImageStyle() {
				const imageUrl = this.avatarImage || this.userProfileImage
				if (imageUrl) {
					return {
						backgroundImage: `url(${imageUrl})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat',
					}
				}
				return {}
			},
		},
	}
</script>

<style lang="scss" scoped>
	$highlightColor: #5383ff;
	$backgroundColor: #fafbff;
	$alteredBackgroundColor: #e4ecff;
	$textColor: #202020;

	.avatar-chat-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
		background-color: $backgroundColor;
		position: relative;
		color: var(--stan-text-dark-color);
	}

	.chat-header {
		padding: 32px 16px 16px;
		background-color: $backgroundColor;
		flex-shrink: 0;
		z-index: 10;
		position: relative;

		.chat-header-content {
			.chat-title {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 12px;

				.header-avatar {
					color: #000;
					width: 40px;
					height: 40px;
					border-radius: 50%;
					overflow: hidden;
				}

				h1 {
					font-size: 20px;
					font-style: normal;
					opacity: 0.8;
				}
			}
		}
	}

	.chat-input-container {
		width: 100%;
		padding: 8px;
		flex-shrink: 0;

		.chat-input-wrapper {
			width: 100%;
			height: 100%;
			padding: 16px;
			position: relative;
			box-shadow: 0px 0px 1px 0px rgba(20, 20, 20, 0.12), 0px 4px 12px 2px rgba(20, 20, 20, 0.08);
			border: 1px solid #e1e5e9;
			border-radius: 16px;

			.message-input {
				flex: 1;
				border: none;
				background: transparent;
				resize: none;
				outline: none;
				font-size: 0.95rem;
				line-height: 1.4;
				color: #333;
				font-family: inherit;
				min-height: 24px;
				max-height: 60px;
				overflow-y: auto;
				padding: 0;
				margin: 0;
				width: 100%;
				vertical-align: top;

				scrollbar-width: none;
				-ms-overflow-style: none;

				&::-webkit-scrollbar {
					display: none;
				}

				&::placeholder {
					color: #9ca3af;
					opacity: 1;
				}

				&:disabled {
					opacity: 0.6;
				}

				&:focus {
					outline: none;
					border: none;
					box-shadow: none;
				}
			}

			.send-button {
				border: none;
				border-radius: 50%;
				width: 40px;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				position: absolute;
				bottom: 16px;
				right: 16px;
				cursor: default;

				&.disabled {
					background-color: #f4f6fd;
					color: #75b1ff;
					opacity: 1;
				}

				svg {
					display: block;
					width: 18px;
					height: 18px;
				}
			}
		}
	}

	.welcome-message-container {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		text-align: center;
		padding: 0 24px;

		.welcome-text {
			font-size: 24px;
			font-weight: 500;
			text-align: center;
			background: linear-gradient(90deg, #00106d 0%, #0a69fa 100%);
			background-clip: text;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			color: transparent;
			line-height: 1.2;

			.emoji {
				background: none;
				-webkit-background-clip: unset;
				-webkit-text-fill-color: $textColor;
				color: initial;
				background-clip: unset;
			}
		}
	}
</style>
